<div class="flex flex-col gap-4 py-2">
  @for (item of editableItems(); track item.key ?? item.label) {
    <div class="flex flex-col gap-1">
      <label [for]="'modal-' + itemEditKey(item)" class="text-gray-600 font-medium text-sm">
        {{ item.label }}
      </label>
      <input
        [id]="'modal-' + itemEditKey(item)"
        type="text"
        pInputText
        class="w-full text-sm"
        [ngModel]="getValue(itemEditKey(item))"
        (ngModelChange)="setValue(itemEditKey(item), $event)"
      />
    </div>
  }
</div>
@if (noChangesMessage(); as msg) {
  <p class="text-amber-700 text-sm mt-2" role="status">
    {{ msg }}
  </p>
}
<div class="flex justify-end gap-2 pt-4 border-t border-gray-200 mt-4">
  <p-button
    label="Cancel"
    variant="outlined"
    severity="secondary"
    [disabled]="saving()"
    (onClick)="cancel()"
  ></p-button>
  <p-button
    [label]="saving() ? 'Saving…' : 'Save'"
    [loading]="saving()"
    [disabled]="saving()"
    (onClick)="save()"
  ></p-button>
</div>
